import { forwardRef, ButtonHTMLAttributes } from 'react';
import { Button } from '../Button';

export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  active?: boolean;
  icon: React.ReactNode;
  'aria-label': string; // Required for accessibility
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
}

/**
 * IconButton component for icon-only buttons
 *
 * @deprecated Use the unified Button component with `icon` prop instead:
 * ```tsx
 * // Old
 * <IconButton icon={<Plus />} aria-label="Add" variant="outline" />
 *
 * // New (recommended)
 * <Button icon={<Plus />} variant="outline" tooltip="Add" />
 * ```
 *
 * This component is kept for backward compatibility and internally uses
 * the unified Button component.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      variant = 'outline',
      size = 'md',
      active = false,
      icon,
      tooltip,
      tooltipPosition,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        variant={variant}
        size={size}
        active={active}
        icon={icon}
        tooltip={tooltip || props['aria-label']}
        tooltipPosition={tooltipPosition}
        {...props}
      />
    );
  }
);

IconButton.displayName = 'IconButton';
